module.exports = __webpack_public_path__ + "static/media/Kishwar_Naheed_Rekhta.8a427342.jpg";